import React, { useLayoutEffect, useRef } from 'react';
import clsx from 'clsx';
import get from 'lodash.get';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import {
  Element,
  CardDetailHeader,
  Breakpoint
} from '@americanexpress/aqx-components';
import {
  getIsSummitCard,
  getStickySideRailData,
  supportUpgradeCta
} from 'page_modules/business-pdp/redux';
import MobileHeader from './MobileHeader';
import {
  hasMemberInfoArrived,
  isGCSMember
} from 'src/universal/redux/cardMemberInfo';
import { isIE11 } from 'core_modules/bootstrap/browsers/browser-detection';
import { getShouldShowMobileHeader } from 'page_modules/business-pdp/components/Hero/redux';
import { hasBothColorPickerAndDynamicApp } from 'page_modules/business-pdp/redux';
import { getPageFirstCardData } from 'src/universal/redux/page';
import styles from './__styles__/index.scss?modules';

const StickyLeftRail = ({
  sideRailData,
  children,
  isSummitCard,
  cmDataArrived,
  isGcsCM,
  hasUpgradeCta,
  pageDispatch,
  shouldShowMobileHeader,
  hasColorPickerAndDynApp
}) => {
  /*  ##### block to fix IE sticky behavior for Summit Hero: starts ##### */
  const handlingScrollEvent = useRef(false);
  const ieScrollHandler = () => {
    if (window.innerWidth <= 1023) {
      return;
    }
    const scrollTopVal = document.documentElement.scrollTop;
    const summitHeroEle = document.querySelector(
      '[class*="purify_desktopHero__flexContainer-"]'
    );
    const heroHeight = summitHeroEle ? summitHeroEle.clientHeight : 0;
    const thresholdValMin = heroHeight + 60;
    const contentEle = document.querySelector(
      'div.sc_or_sticky-side-rail_root > .sc_at_grid_row > .sc_at_grid_colMd8'
    );
    const thresholdValMax = contentEle ? contentEle.clientHeight : 0;
    let positionVal = 'relative';
    if (scrollTopVal >= thresholdValMin && scrollTopVal < thresholdValMax) {
      positionVal = 'fixed';
    }
    const targetEle = document.querySelector(
      'div.sc_or_sticky-side-rail_root > .sc_at_grid_row > .sc_at_grid_colMd3 > div > div'
    );
    if (targetEle) {
      targetEle.style.position = positionVal;
      if (positionVal === 'fixed') {
        targetEle.style.top = '40px';
      }
    }
  };

  useLayoutEffect(() => {
    if (isIE11 && isSummitCard) {
      document.addEventListener('scroll', ieScrollHandler);
      handlingScrollEvent.current = true;
      setTimeout(() => {
        ieScrollHandler();
      }, 800);
    }

    return () => {
      if (handlingScrollEvent.current === true) {
        document.removeEventListener('scroll', ieScrollHandler);
      }
    };
  }, []);
  /* ##### block to fix IE sticky behavior for Summit Hero: ends ##### */

  const waitingCmData = !cmDataArrived;
  const classNameVal = clsx(styles.pdpLayoutWrap, {
    [styles.isSummitCard]: isSummitCard,
    [styles.waitingCmData]: waitingCmData,
    [styles.hasUpgradeCta]: hasUpgradeCta,
    [styles.hasFullBleedingHero]: shouldShowMobileHeader,
    [styles.hasColorPickerAndDynApp]: hasColorPickerAndDynApp
  });

  /*
  US4042664: the latest layout decisions being made regarding the mobile/tablet breakpoints:
  (1) When the card does NOT have the full-bleeding hero, the new design (the 'MobileHeader' implemented
      by US3753317) will be used for both Prospect and CardMember for both Tablet and Mobile breakpoints.
  (2) When the card does have the full-bleeding hero, we hide the entire 'MobileHeader'.
  */
  return (
    <Breakpoint>
      {({ md, sm, current }) => {
        if ((md || sm) && shouldShowMobileHeader) {
          return (
            <div className={classNameVal}>
              <Element Component="div" className={styles.pdpVerticalLayout}>
                <MobileHeader
                  pageDispatch={pageDispatch}
                  breakPoint={current}
                  isGcsCM={isGcsCM}
                />
                {children}
              </Element>
            </div>
          );
        } else if ((md || sm) && !shouldShowMobileHeader) {
          return (
            <div className={classNameVal}>
              <Element Component="div" className={styles.pdpVerticalLayout}>
                {children}
              </Element>
            </div>
          );
        }

        return (
          <div className={classNameVal}>
            <CardDetailHeader {...sideRailData || {}}>{children}</CardDetailHeader>
          </div>
        );
      }}
    </Breakpoint>
  );
};

const mapStateToProps = (state, ownProps) => {
  const urlEep = get(ownProps, 'params.eep') || '';
  const { pageDispatch } = ownProps;
  const card = getPageFirstCardData(state);
  return {
    sideRailData: getStickySideRailData(urlEep, pageDispatch)(state),
    isSummitCard: getIsSummitCard(state),
    cmDataArrived: hasMemberInfoArrived(state),
    isGcsCM: isGCSMember(state),
    hasUpgradeCta: supportUpgradeCta(state),
    shouldShowMobileHeader: getShouldShowMobileHeader(state),
    hasColorPickerAndDynApp: hasBothColorPickerAndDynamicApp(card.shortName)(state),
    pageDispatch
  };
};

export default withRouter(connect(mapStateToProps)(React.memo(StickyLeftRail)));
